import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum GoldenDomeNotificationType {
  SLACK = "SLACK",
}

// Maps to the analyst roles on `HubspotTeamInfo.productAnalysts`. When a
// subscription fires, only analysts whose role appears here are tagged in
// the Slack alert.
export enum GoldenDomeProductArea {
  RETURNS = "returns",
  OMS = "oms",
  MARKETING = "marketing",
  CONVERSION = "conversion",
  SHOPPER_AI = "shopperAI",
}

const notificationSentSchema_ = z.object({
  timestamp: z.date(),
  teamId: z.string(),
  appId: z.string(),
});

const goldenDomeNotificationSchema_ = z.object({
  _id: zExt.objectId(),
  userEmail: z.string(),
  appIds: z.array(z.string()),
  notificationsSent: z.array(notificationSentSchema_),
  title: z.string(),
  customMessage: z.string().optional(),
  notificationType: createEnum(GoldenDomeNotificationType, {
    enumName: "golden_dome_notification_type",
  }),
  includeAppInstallationRemoved: z.boolean().optional(),
  productAreas: z
    .array(
      createEnum(GoldenDomeProductArea, {
        enumName: "golden_dome_product_area",
      }),
    )
    .optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const GoldenDomeNotificationSchema: z.ZodType<GoldenDomeNotification> =
  goldenDomeNotificationSchema_;
export interface GoldenDomeNotification
  extends z.infer<typeof goldenDomeNotificationSchema_> {}
